document.addEventListener('DOMContentLoaded', () => {
    // Helper functions for responsive active containers
    const isDesktopView = () => window.matchMedia('(min-width: 1024px)').matches;
    const getActiveMainImage = () => document.querySelector(isDesktopView() ? '.hidden.lg\\:block .main-image-display' : '.block.lg\\:hidden .main-image-display') || document.querySelector('.main-image-display');
    const getActiveThumbnails = () => document.querySelectorAll(isDesktopView() ? '.hidden.lg\\:block .thumbnail-trigger' : '.block.lg\\:hidden .thumbnail-trigger');

    // 1. Image Gallery Logic (Multi-container scoped)
    document.querySelectorAll('.product-gallery-section').forEach(section => {
        const mainImage = section.querySelector('.main-image-display');
        const thumbnails = section.querySelectorAll('.thumbnail-trigger');
        
        function updateCounter() {
            if (thumbnails.length === 0) return;
            let currentIndex = Array.from(thumbnails).findIndex((t) => t.classList.contains('border-primary'));
            if (currentIndex === -1) currentIndex = 0;
            
            const dots = section.querySelectorAll('.gallery-dot');
            if (dots && dots.length > 0) {
                dots.forEach((dot, idx) => {
                    if (idx === currentIndex) {
                        dot.className = 'gallery-dot h-1.5 rounded-full transition-all duration-300 w-5 bg-primary';
                    } else {
                        dot.className = 'gallery-dot h-1.5 rounded-full transition-all duration-300 w-1.5 bg-primary/30';
                    }
                });
            }
        }

        thumbnails.forEach((thumb) => {
            thumb.addEventListener('click', () => {
                thumbnails.forEach((t) => {
                    t.classList.remove('border-primary');
                    t.classList.add('border-transparent');
                });
                thumb.classList.remove('border-transparent');
                thumb.classList.add('border-primary');

                const newSrc = thumb.dataset.imageUrl;
                if (mainImage) mainImage.src = newSrc;
                updateCounter();
            });
        });

        // Swipe Support for Main Image (Mobile / Touch)
        if (mainImage && thumbnails.length > 1) {
            let touchstartX = 0;
            let touchendX = 0;
            const SWIPE_THRESHOLD = 50;

            mainImage.addEventListener('touchstart', (e) => {
                touchstartX = e.changedTouches[0].screenX;
            }, { passive: true });

            mainImage.addEventListener('touchend', (e) => {
                touchendX = e.changedTouches[0].screenX;
                handleSwipe();
            }, { passive: true });

            function handleSwipe() {
                if (Math.abs(touchendX - touchstartX) < SWIPE_THRESHOLD) return;

                let currentIndex = Array.from(thumbnails).findIndex(t => t.classList.contains('border-primary'));
                if (currentIndex === -1) currentIndex = 0;

                if (touchendX < touchstartX) {
                    currentIndex = (currentIndex + 1) % thumbnails.length;
                } else if (touchendX > touchstartX) {
                    currentIndex = (currentIndex - 1 + thumbnails.length) % thumbnails.length;
                }

                thumbnails[currentIndex].click();
                thumbnails[currentIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }
        }
    });

    // 2. Lightbox Modal Logic
    const lightbox = document.getElementById('ProductLightbox');
    const lightboxClose = document.getElementById('LightboxClose');
    const lightboxContent = document.getElementById('LightboxContent');
    const lightboxImage = document.getElementById('LightboxImage');

    if (lightbox && lightboxClose && lightboxContent && lightboxImage) {
        let isDown = false;
        let moved = false;
        let startX, startY;
        let scrollLeft, scrollTop;

        const openLightbox = () => {
            const activeImage = getActiveMainImage();
            if (!activeImage) return;
            lightboxImage.src = activeImage.src;
            lightboxImage.alt = activeImage.alt;
            
            lightbox.classList.remove('opacity-0', 'pointer-events-none');
            lightbox.classList.add('opacity-100', 'pointer-events-auto');
            document.body.style.overflow = 'hidden';
        };

        const mobileZoomBtn = document.getElementById('MobileZoomBtn');
        if (mobileZoomBtn) {
            mobileZoomBtn.addEventListener('click', openLightbox);
        }

        document.querySelectorAll('.main-image-display').forEach(mainImage => {
            mainImage.addEventListener('click', () => {
                const isMobile = window.matchMedia('(max-width: 767px)').matches;
                if (!isMobile) {
                    openLightbox();
                }
            });
        });

        const closeLightbox = () => {
            lightbox.classList.add('opacity-0', 'pointer-events-none');
            lightbox.classList.remove('opacity-100', 'pointer-events-auto');
            document.body.style.overflow = '';
            
            lightboxImage.classList.remove('zoomed');
            lightboxImage.style.width = '';
            lightboxImage.style.maxWidth = '95vw';
            lightboxImage.style.maxHeight = '95vh';
            lightboxImage.style.cursor = 'zoom-in';

            lightboxImage.style.transform = '';
            lightboxImage.style.transformOrigin = 'center center';
            
            isDown = false;
            moved = false;
            lightboxContent.style.cursor = 'zoom-in';
        };

        lightboxClose.addEventListener('click', closeLightbox);
        const lightboxBackdrop = document.getElementById('LightboxBackdrop');
        lightboxContent.addEventListener('click', (e) => {
            if (e.target === lightboxContent || e.target === lightboxBackdrop) {
                closeLightbox();
            }
        });

        const lightboxPrev = document.getElementById('LightboxPrev');
        const lightboxNext = document.getElementById('LightboxNext');

        if (lightboxPrev && lightboxNext) {
            const navigateLightbox = (direction) => {
                const activeThumbnails = getActiveThumbnails();
                if (!activeThumbnails || activeThumbnails.length <= 1) return;
                
                let currentIndex = Array.from(activeThumbnails).findIndex(t => t.classList.contains('border-primary'));
                if (currentIndex === -1) currentIndex = 0;

                if (direction === 'next') {
                    currentIndex = (currentIndex + 1) % activeThumbnails.length;
                } else {
                    currentIndex = (currentIndex - 1 + activeThumbnails.length) % activeThumbnails.length;
                }

                activeThumbnails[currentIndex].click();
                const activeImage = getActiveMainImage();
                if (activeImage) {
                    lightboxImage.src = activeImage.src;
                    lightboxImage.alt = activeImage.alt;
                }
            };

            lightboxPrev.addEventListener('click', (e) => {
                e.stopPropagation();
                navigateLightbox('prev');
            });

            lightboxNext.addEventListener('click', (e) => {
                e.stopPropagation();
                navigateLightbox('next');
            });
        }

        document.addEventListener('keydown', (e) => {
            if (!lightbox.classList.contains('pointer-events-none')) {
                if (e.key === 'Escape') {
                    closeLightbox();
                } else if (e.key === 'ArrowLeft' && lightboxPrev) {
                    lightboxPrev.click();
                } else if (e.key === 'ArrowRight' && lightboxNext) {
                    lightboxNext.click();
                }
            }
        });

        const isDesktopMouse = window.matchMedia('(pointer: fine)').matches;

        if (isDesktopMouse) {
            lightboxImage.style.cursor = 'zoom-in';
            lightboxContent.style.cursor = 'zoom-in';

            lightboxImage.addEventListener('click', (e) => {
                e.stopPropagation();
                if (moved) {
                    moved = false;
                    return;
                }
                const isZoomed = lightboxImage.classList.toggle('zoomed');
                if (isZoomed) {
                    lightboxImage.style.width = '150%';
                    lightboxImage.style.maxWidth = 'none';
                    lightboxImage.style.maxHeight = 'none';
                    lightboxImage.style.cursor = 'zoom-out';
                    lightboxContent.style.cursor = 'zoom-out';
                    setTimeout(() => {
                        lightboxContent.scrollLeft = (lightboxContent.scrollWidth - lightboxContent.clientWidth) / 2;
                        lightboxContent.scrollTop = (lightboxContent.scrollHeight - lightboxContent.clientHeight) / 2;
                    }, 50);
                } else {
                    lightboxImage.style.width = '';
                    lightboxImage.style.maxWidth = '95vw';
                    lightboxImage.style.maxHeight = '95vh';
                    lightboxImage.style.cursor = 'zoom-in';
                    lightboxContent.style.cursor = 'zoom-in';
                }
            });

            lightboxContent.addEventListener('mousedown', (e) => {
                if (!lightboxImage.classList.contains('zoomed')) return;
                isDown = true;
                moved = false;
                lightboxContent.style.cursor = 'grabbing';
                startX = e.pageX - lightboxContent.offsetLeft;
                startY = e.pageY - lightboxContent.offsetTop;
                scrollLeft = lightboxContent.scrollLeft;
                scrollTop = lightboxContent.scrollTop;
                e.preventDefault();
            });

            lightboxContent.addEventListener('mouseleave', () => {
                if (isDown) {
                    isDown = false;
                    if (lightboxImage.classList.contains('zoomed')) lightboxContent.style.cursor = 'zoom-out';
                }
            });

            lightboxContent.addEventListener('mouseup', () => {
                if (isDown) {
                    isDown = false;
                    if (lightboxImage.classList.contains('zoomed')) lightboxContent.style.cursor = 'zoom-out';
                }
            });

            lightboxContent.addEventListener('mousemove', (e) => {
                if (!isDown) return;
                e.preventDefault();
                const x = e.pageX - lightboxContent.offsetLeft;
                const y = e.pageY - lightboxContent.offsetTop;
                const walkX = x - startX;
                const walkY = y - startY;
                if (Math.abs(walkX) > 5 || Math.abs(walkY) > 5) moved = true;
                lightboxContent.scrollLeft = scrollLeft - walkX * 1.5;
                lightboxContent.scrollTop = scrollTop - walkY * 1.5;
            });
        } else {
            const mobileHint = document.getElementById('LightboxMobileHint');
            let lastTapTime = 0;
            let isMobileZoomed = false;

            function hideMobileHint() {
                if (mobileHint) mobileHint.style.opacity = '0';
            }
            if (mobileHint) setTimeout(hideMobileHint, 2500);

            lightboxImage.addEventListener('touchend', (e) => {
                const now = Date.now();
                const timeSinceLast = now - lastTapTime;
                if (timeSinceLast < 300 && timeSinceLast > 0) {
                    e.preventDefault();
                    hideMobileHint();
                    if (isMobileZoomed) {
                        lightboxImage.style.transform = '';
                        lightboxImage.style.transformOrigin = 'center center';
                        isMobileZoomed = false;
                    } else {
                        const touch = e.changedTouches[0];
                        const rect = lightboxImage.getBoundingClientRect();
                        const offsetX = ((touch.clientX - rect.left) / rect.width) * 100;
                        const offsetY = ((touch.clientY - rect.top) / rect.height) * 100;
                        lightboxImage.style.transformOrigin = `${offsetX}% ${offsetY}%`;
                        lightboxImage.style.transform = 'scale(2)';
                        isMobileZoomed = true;
                    }
                }
                lastTapTime = now;
            }, { passive: false });

            lightboxClose.addEventListener('click', () => {
                lightboxImage.style.transform = '';
                lightboxImage.style.transformOrigin = 'center center';
                isMobileZoomed = false;
                if (mobileHint) mobileHint.style.opacity = '1';
                lastTapTime = 0;
            });
        }
    }

    // 3. Wishlist Logic (Scoped to all instances)
    const productData = window.PRODUCT_DATA;
    const wishlistBtns = document.querySelectorAll('.wishlist-toggle-btn');

    function getWishlist() {
        if (window.EngoodWishlist) return window.EngoodWishlist.getWishlist();
        try { return JSON.parse(localStorage.getItem('engood-wishlist-guest')) || []; } catch (e) { return []; }
    }

    function saveWishlist(wishlist) {
        if (window.EngoodWishlist) {
            window.EngoodWishlist.saveWishlist(wishlist);
        } else {
            try { localStorage.setItem('engood-wishlist-guest', JSON.stringify(wishlist)); } catch (e) {}
            window.dispatchEvent(new CustomEvent('wishlist-updated', { detail: { wishlist } }));
        }
    }

    function isInWishlist(handle) {
        return getWishlist().some((item) => item.handle === handle);
    }

    function updateWishlistUI(isActive) {
        wishlistBtns.forEach(btn => {
            const icon = btn.querySelector('span');
            if (isActive) {
                if (icon) {
                    icon.classList.add('text-red-500');
                    icon.classList.remove('text-text-subtle');
                }
                btn.classList.add('wishlist-active');
                btn.setAttribute('aria-label', 'Remove from wishlist');
            } else {
                if (icon) {
                    icon.classList.remove('text-red-500');
                    icon.classList.add('text-text-subtle');
                }
                btn.classList.remove('wishlist-active');
                btn.setAttribute('aria-label', 'Add to wishlist');
            }
        });
    }

    if (wishlistBtns.length > 0 && productData) {
        updateWishlistUI(isInWishlist(productData.handle));
        
        wishlistBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                let wishlist = getWishlist();
                const index = wishlist.findIndex((item) => item.handle === productData.handle);
                
                if (index > -1) {
                    wishlist.splice(index, 1);
                    updateWishlistUI(false);
                } else {
                    wishlist.push(productData);
                    updateWishlistUI(true);
                    
                    // Show sign in prompt if guest
                    if (window.EngoodCustomer && !window.EngoodCustomer.loggedIn && !sessionStorage.getItem('engood-wishlist-signin-prompted')) {
                        // We dispatch a custom event to trigger the sign in prompt from the global wishlist script
                        window.dispatchEvent(new CustomEvent('wishlist-signin-prompt'));
                    }
                }
                saveWishlist(wishlist);
            });
        });

        // Sync when updated from elsewhere (e.g., removing from the drawer)
        window.addEventListener('wishlist-updated', () => {
            updateWishlistUI(isInWishlist(productData.handle));
        });
    }

    // 4. Variant Selection Logic (Sync across both mobile and desktop instances)
    const variantSelectors = document.querySelectorAll('.single-option-selector');
    const productJsonScript = document.querySelector('script[type="application/json"][id^="ProductJson-"]');

    let variants = [];
    if (productJsonScript) {
        try {
            variants = JSON.parse(productJsonScript.textContent);
        } catch (e) {
            console.error('Error parsing product variants', e);
        }
    }

    variantSelectors.forEach(selector => {
        selector.addEventListener('change', (e) => {
            // Sync selection across any duplicate selectors (mobile vs desktop)
            const changedName = e.target.name;
            const changedVal = e.target.value;
            document.querySelectorAll(`.single-option-selector[name="${changedName}"]`).forEach(el => {
                if (el.value === changedVal && !el.checked) el.checked = true;
            });

            // Get selected options from the active container
            const activeContainer = isDesktopView() ? document.querySelector('.product-form-desktop') : document.querySelector('.product-form-mobile');
            const selectedOptions = Array.from((activeContainer || document).querySelectorAll('.single-option-selector:checked')).map(el => el.value);

            const matchedVariant = variants.find(variant => {
                let match = true;
                selectedOptions.forEach((val, index) => {
                    if (variant[`option${index + 1}`] !== val) match = false;
                });
                return match;
            });

            if (matchedVariant) {
                // Update all variant-id-input fields
                document.querySelectorAll('.variant-id-input').forEach(input => input.value = matchedVariant.id);

                // Update URL
                const url = new URL(window.location);
                url.searchParams.set('variant', matchedVariant.id);
                window.history.replaceState({}, '', url);

                // Update all price elements across both layouts
                document.querySelectorAll('[data-price]').forEach(priceEl => {
                    priceEl.textContent = formatMoney(matchedVariant.price);
                });

                document.querySelectorAll('[data-compare-price]').forEach(compEl => {
                    if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
                        compEl.textContent = formatMoney(matchedVariant.compare_at_price);
                        compEl.classList.remove('hidden');
                    } else {
                        compEl.classList.add('hidden');
                    }
                });

                document.querySelectorAll('[data-unit-price]').forEach(unitEl => {
                    if (matchedVariant.unit_price_measurement) {
                        const referenceValue = matchedVariant.unit_price_measurement.reference_value;
                        const referenceUnit = matchedVariant.unit_price_measurement.reference_unit.replace('kg', 'Kg');
                        const baseUnitString = referenceValue !== 1 ? `${referenceValue}${referenceUnit}` : `${referenceUnit}`;
                        unitEl.textContent = `(${formatMoney(matchedVariant.unit_price)}/${baseUnitString})`;
                        unitEl.classList.remove('hidden');
                    } else {
                        unitEl.classList.add('hidden');
                    }
                });

                // Update PRODUCT_DATA for wishlist
                if (window.PRODUCT_DATA) {
                    window.PRODUCT_DATA.variantId = matchedVariant.id;
                    window.PRODUCT_DATA.price = formatMoney(matchedVariant.price);
                }

                // Update all ATC Buttons & Sticky ATC Bar
                const addToCartBtns = document.querySelectorAll('button[name="add"]');
                const stickyATCBtn = document.getElementById('StickyATCBtn');
                const stickyPrice = document.getElementById('StickyPrice');
                const stickyVariantName = document.getElementById('StickyVariantName');
                
                if (stickyPrice) stickyPrice.textContent = formatMoney(matchedVariant.price);
                if (stickyVariantName) stickyVariantName.textContent = matchedVariant.title === 'Default Title' ? '' : '• ' + matchedVariant.title;

                addToCartBtns.forEach(addToCartBtn => {
                    const addToCartText = window.PRODUCT_DATA?.addToCartText || 'Add to Cart';
                    const soldOutText = window.PRODUCT_DATA?.soldOutText || 'Sold Out';
                    if (matchedVariant.available) {
                        addToCartBtn.disabled = false;
                        addToCartBtn.innerHTML = `<span>${addToCartText}</span>`;
                        addToCartBtn.classList.remove('opacity-50', 'cursor-not-allowed');
                        if (stickyATCBtn) {
                            stickyATCBtn.disabled = false;
                            stickyATCBtn.textContent = addToCartText;
                            stickyATCBtn.classList.remove('opacity-50', 'cursor-not-allowed');
                        }
                    } else {
                        addToCartBtn.disabled = true;
                        addToCartBtn.innerHTML = `<span>${soldOutText}</span>`;
                        addToCartBtn.classList.add('opacity-50', 'cursor-not-allowed');
                        if (stickyATCBtn) {
                            stickyATCBtn.disabled = true;
                            stickyATCBtn.textContent = soldOutText;
                            stickyATCBtn.classList.add('opacity-50', 'cursor-not-allowed');
                        }
                    }
                });

                // Update Variant Image
                if (matchedVariant.featured_image && matchedVariant.featured_image.src) {
                    const newImgSrc = matchedVariant.featured_image.src;
                    document.querySelectorAll('.main-image-display').forEach(img => img.src = newImgSrc);

                    const getFilename = (url) => {
                        if (!url) return '';
                        const parts = url.split('?')[0].split('/');
                        const filename = parts[parts.length - 1];
                        return filename.replace(/_\d+x\d*/, '').replace(/_\d+x/, '').split('_crop_')[0];
                    };

                    const newImgFilename = getFilename(newImgSrc);
                    document.querySelectorAll('.thumbnail-trigger').forEach((thumb) => {
                        thumb.classList.remove('border-primary');
                        thumb.classList.add('border-transparent');
                        const thumbUrl = thumb.dataset.imageUrl;
                        if (thumbUrl && getFilename(thumbUrl) === newImgFilename) {
                            thumb.classList.remove('border-transparent');
                            thumb.classList.add('border-primary');
                        }
                    });
                }
            }
        });
    });

    // 5. Quantity Logic (Scoped across all quantity selectors)
    document.querySelectorAll('.product-qty-btn').forEach((btn) => {
        btn.addEventListener('click', () => {
            const container = btn.closest('[data-variant-id]') || btn.parentElement;
            const input = container.querySelector('.product-qty-input');
            if (!input) return;
            let currentVal = parseInt(input.value) || 1;
            if (btn.dataset.action === 'plus') {
                input.value = Math.min(99, currentVal + 1);
            } else if (btn.dataset.action === 'minus') {
                input.value = Math.max(1, currentVal - 1);
            }
            // Sync all quantity inputs
            document.querySelectorAll('.product-qty-input').forEach(el => el.value = input.value);
        });
    });

    document.querySelectorAll('.product-qty-input').forEach(qtyInput => {
        qtyInput.addEventListener('input', () => {
            let val = qtyInput.value.replace(/\D/g, '');
            if (val !== '') {
                let parsed = parseInt(val);
                if (parsed < 1) parsed = 1;
                if (parsed > 99) parsed = 99;
                qtyInput.value = parsed;
                document.querySelectorAll('.product-qty-input').forEach(el => el.value = parsed);
            }
        });

        qtyInput.addEventListener('blur', () => {
            if (qtyInput.value === '' || parseInt(qtyInput.value) < 1) {
                qtyInput.value = 1;
                document.querySelectorAll('.product-qty-input').forEach(el => el.value = 1);
            }
        });
    });

    // 6. AJAX Add to Cart Logic (Multi-form handlers)
    document.querySelectorAll('.product-form').forEach(productForm => {
        productForm.addEventListener('submit', async (e) => {
            e.preventDefault();

            const submitBtn = productForm.querySelector('button[name="add"]');
            const originalText = submitBtn.innerHTML;
            const variantIdInputObj = productForm.querySelector('.variant-id-input') || productForm.querySelector('[name="id"]');
            const variantId = variantIdInputObj ? variantIdInputObj.value : null;
            const quantity = productForm.querySelector('[name="quantity"]')?.value || 1;

            submitBtn.disabled = true;
            submitBtn.innerHTML = '<span class="material-symbols-outlined text-[20px] animate-spin">progress_activity</span> Adding...';

            try {
                if (window.EngoodCart) {
                    await window.EngoodCart.add(variantId, quantity);

                    if (typeof openCartDrawer === 'function') {
                        openCartDrawer();
                    }

                    const stickyBtn = document.getElementById('StickyATCBtn');
                    submitBtn.classList.add('bg-emerald-600', 'border-emerald-600');
                    submitBtn.innerHTML = '<span class="material-symbols-outlined text-[20px]">check_circle</span> Added!';

                    let stickyOriginalText = '';
                    if (stickyBtn) {
                        stickyOriginalText = stickyBtn.innerHTML;
                        stickyBtn.innerHTML = '<span class="material-symbols-outlined text-[18px] mr-1">check_circle</span> Added!';
                    }

                    setTimeout(() => {
                        submitBtn.disabled = false;
                        submitBtn.classList.remove('bg-emerald-600', 'border-emerald-600');
                        submitBtn.innerHTML = originalText;

                        if (stickyBtn) {
                            stickyBtn.disabled = false;
                            stickyBtn.innerHTML = stickyOriginalText;
                        }
                    }, 1500);
                } else {
                    productForm.submit();
                }
            } catch (error) {
                console.error(error);
                submitBtn.disabled = false;
                submitBtn.innerHTML = originalText;
            }
        });
    });

    // 7. Mobile Sticky ATC Bar Logic (H1)
    const stickyBar = document.getElementById('MobileStickyATC');
    const stickyBtn = document.getElementById('StickyATCBtn');
    const mobileFormAddBtn = document.querySelector('.product-form-mobile button[name="add"]');

    if (mobileFormAddBtn && stickyBar && stickyBtn) {
        stickyBtn.addEventListener('click', () => {
            mobileFormAddBtn.click();
        });

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
                        stickyBar.classList.remove('translate-y-full');
                    } else {
                        stickyBar.classList.add('translate-y-full');
                    }
                });
            },
            { root: null, threshold: 0, rootMargin: '0px' }
        );

        observer.observe(mobileFormAddBtn);
    }
});